// extracted by mini-css-extract-plugin
export default {"main":"Catalogos_main__4nQKg"};